"use client";

import { ROADMAP_STEPS } from "@/constants/home.constants";
import { useRoadmapAnimation } from "@/hooks/useRoadmapAnimation";

export default function RoadmapSection() {
  const { activeStep } = useRoadmapAnimation();

  return (
    <section id="roadmap-section" className="reveal-section space-y-12 py-4">
      <div className="text-center space-y-3">
        <p className="text-xs uppercase tracking-[0.25em] text-[var(--accent)]">The Agile Roadmap</p>
        <h2 className="text-4xl md:text-5xl">
          From idea to production,
          <br />
          in five steps.
        </h2>
      </div>

      <div className="relative mx-auto max-w-3xl">
        {/* Center vertical line */}
        <div className="absolute left-1/2 top-0 h-full w-px -translate-x-1/2 bg-[var(--stroke)]" />

        <div className="space-y-10">
          {ROADMAP_STEPS.map((item, index) => {
            const isLeft = index % 2 === 0;
            const isActive = activeStep === index;

            return (
              <div key={item.step} className="relative flex items-center">
                {/* Left side */}
                <div className={`w-1/2 pr-8 ${isLeft ? "text-right" : ""}`}>
                  {isLeft && (
                    <div
                      className={`transition-all duration-500 ${isActive ? "opacity-100" : "opacity-40"}`}
                    >
                      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--accent)]">
                        Step {String(index + 1).padStart(2, "0")}
                      </p>
                      <p className={`mt-1 text-xl font-semibold ${isActive ? "text-[var(--text)]" : "text-[var(--muted)]"}`}>
                        {item.step}
                      </p>
                      <p className="mt-1 text-sm text-[var(--muted)]">{item.description}</p>
                    </div>
                  )}
                </div>

                {/* Center dot */}
                <div className="absolute left-1/2 -translate-x-1/2 z-10">
                  <div
                    className={`h-4 w-4 rounded-full border-2 transition-all duration-500 ${
                      isActive
                        ? "border-[var(--accent)] bg-[var(--accent)] shadow-[0_0_16px_var(--accent)]"
                        : "border-[var(--stroke)] bg-[var(--panel)]"
                    }`}
                  />
                </div>

                {/* Right side */}
                <div className="w-1/2 pl-8">
                  {!isLeft && (
                    <div
                      className={`transition-all duration-500 ${isActive ? "opacity-100" : "opacity-40"}`}
                    >
                      <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[var(--accent)]">
                        Step {String(index + 1).padStart(2, "0")}
                      </p>
                      <p className={`mt-1 text-xl font-semibold ${isActive ? "text-[var(--text)]" : "text-[var(--muted)]"}`}>
                        {item.step}
                      </p>
                      <p className="mt-1 text-sm text-[var(--muted)]">{item.description}</p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
